import { CubeTimeDimensionGranularity } from "../../../enum/cube-schema.enum";
import { CubeConfigDto } from "../../common/request/cube-config.dto";

export interface QueryMaxScoresRequestParamsDto {
    timezone?: string;
    granularity?: CubeTimeDimensionGranularity;
}